type FieldGetter<T> = (item: T) => string

export function minDate<T>(list: T[], fieldGetter: FieldGetter<T>): Date {
  return new Date(Math.min(...list.map(e => new Date(fieldGetter(e)).getTime())))
}

export function maxDate<T>(list: T[], fieldGetter: FieldGetter<T>): Date {
  return new Date(Math.max(...list.map(e => new Date(fieldGetter(e)).getTime())))
}